module.exports = function() {
  return new Worker(__webpack_public_path__ + "4766c5dff20a72caa4bd.worker.js");
};